import React from 'react';
import './Background.css';
import Silk from './Silk';

const Background = () => {
  return (
    <div className="background-container">
      <Silk
        speed={3.5}
        scale={1}
        color="#7B7481"
        noiseIntensity={1.5}
        rotation={0}
      />
    </div>
  );
};

export default Background; 